<template>
    <div class="ds-settings-page">
        <div v-if="isInitialLoading" class="ds-settings-loading"><Loader /></div>
        <div v-else class="ds-settings-tabs-layout">
            <Tabs :tabs tab-font-size="16" px="65" tab-margin-right="22" borderBottomWidth="2">
                <template v-slot:tab1>
                    <div class="ds-settings-content">
                        <div v-if="settingsError" class="ds-settings-state ds-settings-state-error">
                            <p>Не удалось загрузить общие настройки.</p>
                            <btn @click="loadSettings">Повторить</btn>
                        </div>
                        <GlobalSettings v-else />
                        <EmployeeStatisticsSettings
                            :load-error="employeeStatisticsSettingsError"
                            @retry-load="loadEmployeeStatisticsSettings"
                        />
                        <LunchSettings :load-error="lunchError" @retry-load="loadLunchSettings" />
                    </div>
                </template>
                <template v-slot:tab2>
                    <div class="ds-settings-content"><RolesSettings /></div>
                </template>
                <template v-slot:tab3>
                    <div class="ds-settings-content"><PositionSettings /></div>
                </template>
                <template v-slot:tab4>
                    <div class="ds-settings-content">
                        <div v-if="settingsError" class="ds-settings-state ds-settings-state-error">
                            <p>Не удалось загрузить настройки биржи смен.</p>
                            <btn @click="loadSettings">Повторить</btn>
                        </div>
                        <ExchangeSettings v-else />
                    </div>
                </template>
            </Tabs>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import Tabs from '@/components/Tabs.vue'
import { Tab } from '@/types'
import { useSettingsStore } from '@/stores/settingsStore'
import { useAuthStore } from '@/stores/authStore'
import GlobalSettings from '@/components/settings/GlobalSettings.vue'
import EmployeeStatisticsSettings from '@/components/settings/EmployeeStatisticsSettings.vue'
import ExchangeSettings from '@/components/settings/ExchangeSettings.vue'
import LunchSettings from '@/components/settings/LunchSettings.vue'
import PositionSettings from '@/components/settings/PositionSettings.vue'
import Loader from '@/ui/Loader.vue'
import RolesSettings from '@/components/roles/RolesSettings.vue'

const settingsStore = useSettingsStore()
const authStore = useAuthStore()

const tabs: Tab[] = [
    { name: 'tab1', label: 'Общие настройки' },
    { name: 'tab2', label: 'Роли', disabled: !authStore.permissions?.can_edit_roles },
    { name: 'tab3', label: 'Должности' },
    { name: 'tab4', label: 'Биржа смен',disabled: !authStore.permissions?.can_manage_shift_exchange }
]

const isInitialLoading = ref(true)
const settingsError = ref(false)
const lunchError = ref(false)
const employeeStatisticsSettingsError = ref(false)

const loadSettings = async () => {
    settingsError.value = Boolean(await settingsStore.fetchSettings())
}

const loadLunchSettings = async () => {
    lunchError.value = Boolean(await settingsStore.fetchLunchSettings())
}

const loadEmployeeStatisticsSettings = async () => {
    employeeStatisticsSettingsError.value = Boolean(await settingsStore.fetchEmployeeStatisticsSettings())
}

const init = async () => {
    isInitialLoading.value = true
    await loadSettings()
    await loadLunchSettings()
    await loadEmployeeStatisticsSettings()
    isInitialLoading.value = false
}

onMounted(() => {
    init()
})
</script>
